<ng-container *ngIf="cubeDefinition?.cubeName === 'ProductSales'">
    <wbo-search-form-field *extendedField="'[Product].[product].[product]'">
        <wbo-sellable-multi-select-search-control></wbo-sellable-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category top level].[category top level]'">
        <wbo-category-multi-select-search-control [maxLevel]="0"></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category primary].[category primary]'">
        <wbo-category-multi-select-search-control></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Employee].[employee].[employee]'">
        <wbo-employee-multi-select-search-control></wbo-employee-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Outlet].[outlet].[outlet]'">
        <wbo-outlet-multi-select-search-control></wbo-outlet-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Outlet].[state].[state]'">
        <wbo-state-multi-select-search-control></wbo-state-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour of day].[hour of day]'">
        <wbo-hour-of-day-multi-select-search-control></wbo-hour-of-day-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour quarter].[hour quarter]'">
        <wbo-hour-quarter-multi-select-search-control></wbo-hour-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[day of week].[day of week]'">
        <wbo-day-of-week-multi-select-search-control></wbo-day-of-week-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[week of year].[week of year]'">
        <wbo-week-of-year-multi-select-search-control></wbo-week-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[month of year].[month of year]'">
        <wbo-month-of-year-multi-select-search-control></wbo-month-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[calendar quarter of year].[calendar quarter of year]'">
        <wbo-calendar-quarter-of-year-multi-select-search-control></wbo-calendar-quarter-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[date].[date]'">
        <wbo-date-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-date-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year month].[year month]'">
        <wbo-year-month-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                    [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-month-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year calendar quarter].[year calendar quarter]'">
        <wbo-year-calendar-quarter-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                               [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-calendar-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year by calendar quarter].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SaleComponent].[sale component].[sale component]'">
        <wbo-bi-price-component-multi-select-search-control></wbo-bi-price-component-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SaleType].[sale type].[sale type]'">
        <wbo-bi-sale-type-multi-select-search-control></wbo-bi-sale-type-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SellableType].[sellable type].[sellable type]'">
        <wbo-bi-sellable-type-multi-select-search-control></wbo-bi-sellable-type-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[HasEntitlement].[has entitlement].[has entitlement]'">
        <wbo-entitlement-sale-single-select-search-control></wbo-entitlement-sale-single-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Entitlement].[promotion].[promotion]'">
        <wbo-entitlement-promotion-multi-select-search-control></wbo-entitlement-promotion-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Entitlement].[promotion distribution].[promotion distribution]'">
        <wbo-entitlement-distribution-multi-select-search-control></wbo-entitlement-distribution-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[ExpenseType].[expense type].[expense type]'">
        <wbo-bi-expense-type-multi-select-search-control></wbo-bi-expense-type-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[ExpenseAccount].[expense account].[expense account]'">
        <wbo-account-multi-select-search-control [accountingType]="[1001, 1002]"></wbo-account-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[KvdDisplay].[display].[display]'">
        <wbo-order-processor-multi-select-search-control [capability]="OrderProcessorCapability.KVD"></wbo-order-processor-multi-select-search-control>
    </wbo-search-form-field>
</ng-container>

<ng-container *ngIf="cubeDefinition?.cubeName === 'KVDDisplay'">
    <wbo-search-form-field *extendedField="'[Time].[hour of day].[hour of day]'">
        <wbo-hour-of-day-multi-select-search-control></wbo-hour-of-day-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour quarter].[hour quarter]'">
        <wbo-hour-quarter-multi-select-search-control></wbo-hour-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[day of week].[day of week]'">
        <wbo-day-of-week-multi-select-search-control></wbo-day-of-week-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[week of year].[week of year]'">
        <wbo-week-of-year-multi-select-search-control></wbo-week-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[month of year].[month of year]'">
        <wbo-month-of-year-multi-select-search-control></wbo-month-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[calendar quarter of year].[calendar quarter of year]'">
        <wbo-calendar-quarter-of-year-multi-select-search-control></wbo-calendar-quarter-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[date].[date]'">
        <wbo-date-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-date-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year month].[year month]'">
        <wbo-year-month-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                    [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-month-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year calendar quarter].[year calendar quarter]'">
        <wbo-year-calendar-quarter-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                               [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-calendar-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year by calendar quarter].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[KvdDisplay].[display].[display]'">
        <wbo-order-processor-multi-select-search-control [capability]="OrderProcessorCapability.KVD"></wbo-order-processor-multi-select-search-control>
    </wbo-search-form-field>
</ng-container>

<ng-container *ngIf="cubeDefinition?.cubeName === 'KVDItems'">
    <wbo-search-form-field *extendedField="'[Product].[product].[product]'">
        <wbo-sellable-multi-select-search-control></wbo-sellable-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category top level].[category top level]'">
        <wbo-category-multi-select-search-control [maxLevel]="0"></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category primary].[category primary]'">
        <wbo-category-multi-select-search-control></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Outlet].[outlet].[outlet]'">
        <wbo-outlet-multi-select-search-control></wbo-outlet-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Outlet].[state].[state]'">
        <wbo-state-multi-select-search-control></wbo-state-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour of day].[hour of day]'">
        <wbo-hour-of-day-multi-select-search-control></wbo-hour-of-day-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour quarter].[hour quarter]'">
        <wbo-hour-quarter-multi-select-search-control></wbo-hour-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[day of week].[day of week]'">
        <wbo-day-of-week-multi-select-search-control></wbo-day-of-week-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[week of year].[week of year]'">
        <wbo-week-of-year-multi-select-search-control></wbo-week-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[month of year].[month of year]'">
        <wbo-month-of-year-multi-select-search-control></wbo-month-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[calendar quarter of year].[calendar quarter of year]'">
        <wbo-calendar-quarter-of-year-multi-select-search-control></wbo-calendar-quarter-of-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[date].[date]'">
        <wbo-date-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-date-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year month].[year month]'">
        <wbo-year-month-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                    [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-month-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year calendar quarter].[year calendar quarter]'">
        <wbo-year-calendar-quarter-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                                               [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-calendar-quarter-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[year by calendar quarter].[year]'">
        <wbo-year-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-year-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SaleType].[sale type].[sale type]'">
        <wbo-bi-sale-type-multi-select-search-control></wbo-bi-sale-type-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SellableType].[sellable type].[sellable type]'">
        <wbo-bi-sellable-type-multi-select-search-control></wbo-bi-sellable-type-multi-select-search-control>
    </wbo-search-form-field>
</ng-container>

<ng-container *ngIf="cubeDefinition?.cubeName === 'SalesDaily'">
    <wbo-search-form-field *extendedField="'[Product].[product].[product]'">
        <wbo-sellable-multi-select-search-control></wbo-sellable-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category top level].[category top level]'">
        <wbo-category-multi-select-search-control [maxLevel]="0"></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Product].[category primary].[category primary]'">
        <wbo-category-multi-select-search-control></wbo-category-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Time].[hour of day].[hour of day]'">
        <wbo-hour-of-day-multi-select-search-control></wbo-hour-of-day-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[day of week].[day of week]'">
        <wbo-day-of-week-multi-select-search-control></wbo-day-of-week-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[Date].[date].[date]'">
        <wbo-date-multi-select-search-control [endDate]="cubeDefinition.maxAvailableEndDate"
                                              [startDate]="cubeDefinition.minAvailableStartDate">
        </wbo-date-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SaleComponent].[sale component].[sale component]'">
        <wbo-bi-price-component-multi-select-search-control></wbo-bi-price-component-multi-select-search-control>
    </wbo-search-form-field>
    <wbo-search-form-field *extendedField="'[SaleType].[sale type].[sale type]'">
        <wbo-bi-sale-type-multi-select-search-control></wbo-bi-sale-type-multi-select-search-control>
    </wbo-search-form-field>
</ng-container>

